import { render, staticRenderFns } from "./ModalRelatarProblemaSimulado.vue?vue&type=template&id=4d1bd214"
import script from "./ModalRelatarProblemaSimulado.vue?vue&type=script&lang=js"
export * from "./ModalRelatarProblemaSimulado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports